import './HowToStart.scss'

export default function HowToStart(){

    const steps = [
        'Залиште свій запит',
        'Отримайте консультацію від нашого менеджера',
        "Відвідайте пробне заняття",
        "Оберіть зручний час для занять",
        "Розпочинайте навчання"
    ]

    return(
        <div className="HowToStart">
            <div className="wrapper">
                <div className="img_block">
                    <img src="/c5.png" alt="student" />
                </div>
                <div className="steps">
                    <h2 className='title'>Як розпочати навчання?</h2>
                    
                    {steps.map((el, index) => {
                        return <div key={index} className="step">{index+1}. {el}</div>
                    })}
                </div>
            </div>
        </div>
    )
}